module.exports = __webpack_public_path__ + "img/background_2.bae0d276.jpg";